module.exports = __webpack_public_path__ + "img/gpd_logo.03ed06c5.png";